import React from 'react';

export default function RedCapeSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      {/* Cape body - flowing */}
      <path d="M10 6C10 6 8 18 6 28C4 34 10 38 20 38C30 38 36 34 34 28C32 18 30 6 30 6Z" fill="#CC2020" />
      {/* Cape inner shadow */}
      <path d="M12 8C12 8 10 18 8 28C7 32 12 36 20 36C28 36 33 32 32 28C30 18 28 8 28 8Z" fill="#AA1818" />
      {/* Cape flow lines */}
      <path d="M14 12C14 18 12 26 14 32" stroke="#DD3030" strokeWidth="0.8" fill="none" opacity="0.4" />
      <path d="M20 10C20 16 20 24 20 34" stroke="#DD3030" strokeWidth="0.8" fill="none" opacity="0.3" />
      <path d="M26 12C26 18 28 26 26 32" stroke="#DD3030" strokeWidth="0.8" fill="none" opacity="0.4" />
      {/* Collar / clasp */}
      <path d="M10 6C12 4 18 3 20 3C22 3 28 4 30 6" stroke="#D4A830" strokeWidth="2" strokeLinecap="round" fill="none" />
      {/* Gold clasp gem */}
      <circle cx="20" cy="6" r="2.5" fill="#D4A830" />
      <circle cx="20" cy="6" r="1.5" fill="#E84040" />
      <circle cx="19.5" cy="5.5" r="0.5" fill="#FF8888" />
    </svg>
  );
}
